module.exports = __webpack_public_path__ + "img/main.c0a3da9c.png";